import React from 'react';
import { ReactComponent as Logo } from '../../stripelogogrey.svg';

const StripeLogo = () => {
	return (
		<Logo style={{ height: '34px', color: '#C4C4C4' }} className="w-100 my-2" />
	);
};
export default StripeLogo;
